import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getActionIconButtonSize, Icon } from './inline-base-styles';
import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import { LinkButton, LinkIconButton } from './link-button';
import styled from 'styled-components';

const MarginButton = styled(LinkButton)`
  margin-left: 6px;
`;

export interface ExportButtonProps {
  text?: string;
  startIcon?: React.ReactNode;
  withoutText?: boolean;
  disabled?: boolean;
  canExport?: boolean;
  size?: 'large' | 'medium' | 'small';
  onClick?: () => void;
}

export const ExportButtonWithText: React.FC<
  Omit<ExportButtonProps, 'withoutText'>
> = ({ text, canExport, ...rest }) => {
  const { t } = useTranslation(['translation', 'admin']);
  const location = useLocation();

  return (
    <MarginButton
      variant="contained"
      color="primary"
      size="small"
      to={`${location.pathname}/export`}
      startIcon={<Icon icon={faFileExport} aria-hidden="true" />}
      {...rest}
    >
      <span className="d-none d-lg-inline">
        {String(t(text || `global.buttons.export`))}
      </span>
    </MarginButton>
  );
};

export const ExportButtonWithoutText: React.FC<
  Omit<ExportButtonProps, 'text' | 'withoutText'>
> = ({ canExport, size = 'small', ...rest }) => {
  const location = useLocation();
  const dimension = getActionIconButtonSize(size);

  return (
    <LinkIconButton
      color="primary"
      size={size}
      to={`${location.pathname}/export`}
      style={{
        width: dimension,
        minWidth: dimension,
        maxWidth: dimension,
        height: dimension,
        minHeight: dimension,
        maxHeight: dimension,
        marginBottom: '0',
        padding: '0',
      }}
      {...rest}
    >
      <Icon icon={faFileExport} size="sm" />
    </LinkIconButton>
  );
};
